import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/food-feature"

export const getFoodFeature = async foodFeatureId => {
  const response = await farasod.get(`${endpoint}/${foodFeatureId}`)

  return response.data
}

export const getFoodFeatures = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createFoodFeature = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const updateFoodFeature = async (data, foodFeatureId) => {
  const response = await farasod.patch(`${endpoint}/${foodFeatureId}`, data)

  return response.data
}

export const deleteFoodFeature = async foodFeatureId => {
  const response = await farasod.delete(`${endpoint}/${foodFeatureId}`)

  return response.data
}